var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","d":"M12 12c2.271 0 5 .435 5 3.868 0 5.07-8.67 5.506-9.854 1.132M12 12h9m-9 0H3m4-3.868C7 3.062 15.67 2.626 16.854 7"}})
}
var staticRenderFns = []

export { render, staticRenderFns }